<template>
    <div class="wrap-content">
        <router-link to="/">
            <!-- <p class="title-logo">MetalX</p> -->
            <img src="../assets/abi-vertical.png" alt="" class="img-title" />
        </router-link>
        <div class="hello">
            <div class="content-right">
                <p class="brand">Login Admin</p>
                <b-alert show variant="danger" v-show="status == 404">Akun tidak terdaftar</b-alert>
                <b-alert show variant="danger" v-show="status == 400">Username atau Password salah</b-alert>
                <form @submit.prevent="login">
                    <div class="form-group">
                        <label for="">Username</label>
                        <input type="text" class="form-input" placeholder="Username" v-model="$v.form.data_pribadi.$model" name="data_pribadi" />
                        <div class="error" v-if="$v.form.data_pribadi.$error">
                            Email tidak boleh kosong
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="">Password</label>
                        <input :type="type" class="form-input" placeholder="Password" v-model="$v.form.password.$model" />
                        <b-icon v-show="selected === false" icon="eye-fill" class="icon-eye" @click="showEye"></b-icon>
                        <b-icon v-show="selected === true" icon="eye-slash-fill" class="icon-eye" @click="showEye"></b-icon>
                        <div class="error" v-if="$v.form.password.$error">
                            Password tidak boleh kosong
                        </div>
                    </div>
                    <div class="error" v-show="response">{{ response }}</div>
                    <div class="footer-form">
                        <button class="btn-primer" type="submit">
                            <Loading class="loader" v-show="isLoading" />
                            <div v-show="isLoading == false">Login</div>
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import Loading from "../assets/Loading";
import axios from "axios";

import sha256 from "sha256";

export default {
    components: {
        Loading,
    },
    data() {
        return {
            form: {
                data_pribadi: "",
                password: "",
            },
            selected: false,
            type: "password",
            role: localStorage.getItem("role"),
            isLoading: false,
            status: "",
        };
    },
    validations: {
        form: {
            data_pribadi: {
                required,
            },
            password: {
                required,
            },
        },
    },
    methods: {
        showEye() {
            if (this.type == "password") {
                this.type = "text";
                this.selected = !this.selected;
            } else {
                this.type = "password";
                this.selected = !this.selected;
            }
        },
        login() {
            this.$v.form.$touch();
            if (this.$v.form.$anyError) {
                return;
            }
            this.isLoading = true;
            window.grecaptcha.enterprise.ready(async () => {
                // const tokenCaptcha = await window.grecaptcha.enterprise.execute("6LeqJlIfAAAAAKiLEDw-dGkgLpyj695P4IoTuMa8", { action: "LOGINBROKERPBKABI" });
                const tokenCaptcha = await window.grecaptcha.enterprise.execute("6Lcpm-AkAAAAAKKack5w7MK_Hq5Ix3Zt5OztXSc8", { action: "LOGINBROKERPBKABI" });
                // console.log(tokenCaptcha);
                axios
                    // .get(process.env.VUE_APP_GEO_URL)
                    .get(process.env.VUE_APP_GEO_URL_PROD)
                    .then((resGeo) => {
                        let latLong = resGeo.data.cityLatLong.split(",");
                        const headers = {
                            latitude: latLong[0],
                            longitude: latLong[1],
                            city: resGeo.data.city,
                            region: resGeo.data.region,
                            country: resGeo.data.country,
                            "ip-Address": resGeo.data.userIP,
                        };
                        const data = {
                            username: this.form.data_pribadi,
                            password: sha256(this.form.password),
                            clientCaptchaKey: tokenCaptcha,
                        };
                        axios
                            .post("/v2/user/auth", data, {
                                headers: headers,
                            })
                            .then((resLogin) => {
                                this.isLoading = false;
                                let status = resLogin.data.data.status_code;
                                if (status == "00") {
                                    localStorage.setItem("token", resLogin.data.data.token);
                                    localStorage.setItem("role", resLogin.data.data.role);
                                    localStorage.setItem("status_token", true);
                                    localStorage.setItem("access", JSON.stringify(resLogin.data.data.service_access));
                                    window.location.href = "/admin";
                                } else {
                                    this.status = 400;
                                    this.isLoading = false;
                                }
                            })
                            .catch((e) => {
                                let error = e.response;
                                console.log(error);
                                this.status = error.status;
                                this.isLoading = false;
                            });
                    })
                    .catch((error) => {
                        this.isLoading = false;
                        console.log(error.status);
                    });
            });
        },
    },
    created() {
        this.scriptCaptcha = document.createElement("script");

        // this.scriptCaptcha.src = "https://www.google.com/recaptcha/enterprise.js?render=6LeqJlIfAAAAAKiLEDw-dGkgLpyj695P4IoTuMa8"; //dev
        this.scriptCaptcha.src = "https://www.google.com/recaptcha/enterprise.js?render=6Lcpm-AkAAAAAKKack5w7MK_Hq5Ix3Zt5OztXSc8"; //prod
        this.scriptCaptcha.async = true;

        document.body.appendChild(this.scriptCaptcha);
    },
    beforeDestroy() {
        document.body.removeChild(this.scriptCaptcha);
    },
};
</script>

<style scoped>
.img-title {
    height: 98px;
    margin-bottom: 40px;
}
.wrap-content {
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(197, 151, 51, 0.4);
    flex-direction: column;
}

.title-logo {
    position: relative;
    top: -30px;
    font-size: 45px;
    font-weight: bold;
    color: #1e354a;
}

.hello {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.content-left {
    width: 200px;
    background: #1e354a;
    height: 405px;
    color: white;
    padding: 25px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 10px 0 0 10px;
}

.content-left p {
    font-size: 20px;
    margin-bottom: 40px;
}

.content-right {
    width: 40%;
    min-height: 29rem;
    background: white;
    padding: 30px 50px;
    border-radius: 5px;
    border: 1px solid #ddd;
    box-shadow: 0px 8px 20px 0px rgb(0 0 0 / 15%);
}

.form-input {
    width: 100%;
    font-size: 12px;
    border-radius: 0;
    height: 37px;
    border: none;
    border-bottom: 1px solid #9a9a9a;
    padding: 0px;
    text-transform: none;
}

label {
    font-size: 13px;
    display: inline-block;
    margin-bottom: 0px;
}

.brand {
    font-size: 25px;
    font-weight: bold;
    margin: 0 0 50px;
    position: relative;
}

.brand::after {
    content: "";
    width: 47px;
    height: 3px;
    background: #c59733;
    position: absolute;
    bottom: -3px;
    left: 2px;
}

.footer-form {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    top: 25px;
}

.btn-primer {
    margin: 15px 0 0;
}

.btn-scondary {
    background: transparent;
    font-size: 13px;
    width: 125px;
    height: 39px;
}

.have-account {
    font-size: 14px;
    margin: 10px;
    text-decoration: underline;
    color: #707070;
}

.form-group {
    position: relative;
    margin: 0 0 35px;
}

.form-input:focus {
    box-shadow: none;
    border-color: #c59733;
}

.icon-eye {
    position: absolute;
    font-size: 30px;
    right: 15px;
    top: 25px;
}

.register {
    font-size: 14px;
    margin-left: 30px;
}

.register-button {
    font-weight: bold;
    color: #1f354a;
    cursor: pointer;
}

.register-button:hover {
    text-decoration: underline;
}

@media (min-width: 720px) and (max-width: 1024px) {
    .hello {
        flex-wrap: wrap;
    }

    .content-left {
        text-align: center;
    }

    .content-right {
        margin: -100px 0 0 0px;
    }

    .btn-primer {
        width: 225px;
        display: block;
        margin: 40px auto;
    }

    .have-account {
        text-align: center;
    }

    .icon-eye {
        right: 20px;
    }
}
</style>
